'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Izvēlieties laiku'
};

exports['default'] = locale;